import styled from 'styled-components'

interface Props {
  email: string
}

export const EmailLink = ({ email }: Props) => {
  return <Wrapper href={`mailto:${email}`}>{email}</Wrapper>
}

const Wrapper = styled.a`
  color: ${({ theme }) => theme.colors.OxidizedGreen};
  text-decoration: none;
`
